<template>
  <v-dialog v-model="dialog" width="550">
    <template v-slot:activator="{ on, attrs }">
      <button class="customBtn" :vBind="attrs" :vOn="on" @click="openModal">
        {{
          localStorage.translations.pages['setting-offer_agreement']['dialog-publish-buttons']
            .publish
        }}
      </button>
    </template>
    <transition :duration="150">
      <div class="edit" v-if="dialog">
        <!-- <CloseModalBtn :closeModal="closeModal" /> -->
        <h5>
          {{ localStorage.translations.pages['setting-offer_agreement']['dialog-publish'].text }}
        </h5>
        <p class="f20">{{ name }}</p>
        <div class="buttons">
          <button class="customBtn" @click="publish">
            {{
              localStorage.translations.pages['setting-offer_agreement']['dialog-publish-buttons']
                .publish
            }}
          </button>
          <button class="customBtn reverse" @click="closeModal">
            {{ localStorage.translations.pages.common.buttons.otmenit }}
          </button>
        </div>
      </div>
    </transition>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'OfferAgreementPostModal',
  components: {},
  props: ['id', 'name'],
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    ...mapActions('offerAgreement', ['onOfferAgreementPublishLast']),
    openModal() {
      this.dialog = true
    },
    closeModal() {
      this.dialog = false
    },
    publish() {
      this.onOfferAgreementPublishLast()
        .then((response) => {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications[
                  'izmeneniya-uspeshno-sohraneny'
                ],
              IsError: false,
            },

            { root: true },
          )
          this.closeModal()
          this.$router.push({
            name: 'settingOfferAgreement',
            query: {
              page: 1,
              limit: 10,
            },
          })
        })
        .catch((err) => {
          if (err.response.data.errors) {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
          }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.edit:deep() {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 30px 30px rgba(39, 127, 175, 0.2);
  text-align: center;
  padding: 60px;
  position: relative;
  .close {
    padding: 16px;
  }

  h5 {
    text-align: center;
    margin-bottom: 20px;
  }
  p {
    margin-bottom: 30px;
  }
  .buttons {
    display: grid;
    grid-template-columns: repeat(2, max-content);
    justify-content: center;
    column-gap: 20px;
  }
}
</style>
